import request from "@/utils/request";

// 列表(主数据列表)
export function loadMessageNotifyPersonnelListDataApi(data) {
  return request({
    url: "web/messageNotifyPersonnel/listData",
    method: "post",
    data
  });
}
// 导出
export function loadMessageNotifyPersonnelExportDataApi(data) {
  return request({
    url: "web/messageNotifyPersonnel/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateMessageNotifyPersonnelApi(data) {
  return request({
    url: "web/messageNotifyPersonnel/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initMessageNotifyPersonnelApi(data) {
  return request({
    url: "web/messageNotifyPersonnel/init",
    method: "post",
    data
  });
}

// 获取业务单据信息清单
export function loadBusinessDataApi(data) {
  return request({
    url: "web/businessMessageDefinition/listBusinessData",
    method: "post",
    data
  });
}

// 根据业务单据获取定义的消息字段信息
export function loadMessageDefinitionDataApi(data) {
  return request({
    url: "web/businessMessageDefinition/loadMessageDefinition",
    method: "post",
    data
  });
}
